module.exports = __webpack_public_path__ + "img/mealreminder-text-2.dc42a908.png";